import { getSanityClient } from "~/configs/sanity";
import { insightsSearchQuery } from "~/feature/insights/queries";
import type { IInsight } from "~/feature/insights/types";
import { buildInsightsSearchPattern } from "~/feature/insights/utils/buildInsightsSearchPattern";
import { api } from "~/store/api";
import { handleError } from "~/utils/handleError";

export const insightsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchInsights: builder.query<IInsight[], { query: string }>({
      queryFn: async ({ query }) => {
        try {
          const insights = await getSanityClient().fetch<IInsight[]>(
            insightsSearchQuery,
            { pattern: buildInsightsSearchPattern(query) }
          );

          return { data: insights };
        } catch (error) {
          handleError(error);

          return {
            error: { status: "CUSTOM_ERROR", error: String(error) },
          };
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useSearchInsightsQuery } = insightsApi;
